import { render, staticRenderFns } from "./clientOverview_CommentsAddEditRemove.vue?vue&type=template&id=6bc6dfce&scoped=true&"
import script from "./clientOverview_CommentsAddEditRemove.vue?vue&type=script&lang=js&"
export * from "./clientOverview_CommentsAddEditRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6dfce",
  null
  
)

export default component.exports